import React, { Component } from "react";
import DialogContainer from "../../containers/DialogContainer";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { DialogActions } from "@material-ui/core";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as dialogActions from '../../redux/actions/dialogactions'

class ConfirmationDialog extends Component {

  selectOptions(option){
    if(option){
      console.log("selected True!")
      this.props.dialogActions.acceptConfirmDialog();
    }
    else{
      console.log("selected False!")
      this.props.dialogActions.closeConfirmDialog();
    }
  }

  render() {
    const {dialog, dialogActions} = this.props
    return (
      <DialogContainer
        open={dialog.open}
        title={
          <Typography variant="h6" style={{ color: '#43a047'}}>
            {dialog.title}
          </Typography>
        } 
        contentText={dialog.message}
        actions={
          <DialogActions>
            <Button color="secondary" onClick={dialogActions.cancelConfirmDialog}>{dialog.cancelText}</Button>
            <Button color="primary" onClick={()=>this.selectOptions(true)}>{dialog.confirmText}</Button>
          </DialogActions>
        }
        disableTypography
      >
        {/* <Typography variant="h4" > */}
          {/* {this.props.content} */}
          {this.props.children === 'undefined' ? null : this.props.children}
        {/* </Typography> */}
      </DialogContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    dialog: state.dialog.confirm
  }
}

const mapDispatchToProps = dispatch =>{
  return {
    dialogActions: bindActionCreators(dialogActions,dispatch)
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(ConfirmationDialog)
